import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { PaginationParams } from 'models';

export const getBuyersCounteroffersMore = createAsyncThunk(
	'secondaryMarket/getBuyersCounteroffersMore',
	async (params?: PaginationParams) => {
		return await SecondaryMarketService.getBuyerCounteroffers(params);
	},
);
